import type * as React from "react";
import { type ReactNode } from "react";
import classNames from "classnames";

interface CartTableHeaderCellProps {
  children?: ReactNode;
  title: ReactNode;
  subTitle?: ReactNode;
  alignEnd?: boolean;
  first?: boolean;
  firstOnRightSide?: boolean;
  lastOnRightSide?: boolean;
  className?: string;
  internal?: boolean;
}

const CartProductTableHeaderCell: React.FC<CartTableHeaderCellProps> = (props) => {
  const { title, subTitle, alignEnd, first, className, internal, firstOnRightSide, lastOnRightSide } = props;

  const cls = classNames(
    {
      "scha__cart__product-table__header-cell": true,
      first: first,
      "first-on-right": firstOnRightSide,
      "last-on-right": lastOnRightSide,
      "align-end": alignEnd,
    },
    className,
  );

  return (
    <div className={cls}>
      {internal && <div className={"scha__cart__product-table__header-cell__internal-bg"} />}
      <div className={"scha__cart__product-table__header-cell__title"}>{title}</div>
      <div className={"scha__cart__product-table__header-cell__subtitle"}>{subTitle}</div>
    </div>
  );
};

export default CartProductTableHeaderCell;
